  import React, { useEffect, useRef, useState } from "react";

  export const LazyImage = ({ src,setShowModal,activeNavTab,className }) => {
    // const [imageURL, setImageURL] = useState(null);
    const [imageError, setImageError] = useState(false);
    const [retryCount, setRetryCount] = useState(0);
    const [imageLoaded, setImageLoaded] = useState(false);

    // useEffect(() => {
    //   async function fetchImage() {
    //     try {
    //       const response = await fetch(src);
    //       if (!response.ok) {
    //         throw new Error(response.statusText);
    //       }
    //       const imageData = await response.blob();
    //       setImageURL(URL.createObjectURL(imageData));
    //       setImageLoaded(true);
    //     } catch (err) {
    //       setImageError(true);
    //     }
    //   }
      // if (src) {
      //   setImageError(false);
      //   setImageLoaded(false);
      //   fetchImage();
      // }
    // }, [src]);

    const imageRef = useRef(null);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            const img = entry.target;
            // img.src = imageURL;
            img.src = src;
            observer.unobserve(img);
          }
        },
        {
          rootMargin: "90px",
        }
      );

      if (imageRef.current) {
        observer.observe(imageRef.current);
      }

      return () => {
        observer.disconnect();
      };
    }, [src]);

    const handleRefetch = () => {
      setShowModal(false);
      setRetryCount((count) => count + 1);
      setImageError(false);
      setImageLoaded(false);
    };

    return (
      <>
        {!imageLoaded && !imageError && (
          <strong
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            Loading...
            <div
              style={{
                width: "15px",
                height: "15px",
              }}
              className="spinner-grow text-primary"
              role="status"
            >
              <span className="sr-only">Loading...</span>
            </div>
          </strong>
        )}
        {imageError && retryCount < 3 && (
          <button className="retryVButtonForImage" onClick={handleRefetch}>
            Refetch
          </button>
        )}
        
        <img
          className="h-50px .w-sm-75 img-fluid cursor-pointer"
          alt="Not Found"
          // src={src}
          ref={imageRef}
          // onContextMenu={(event) => event.preventDefault()}
          // style={{ display: imageLoaded ? "block" : "none" }}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(true)}
          />
      </>
    );
  };
